// NATIVE 

// INSTALLED 
import  { AxiosInstance } from 'axios';


// CUSTOM 
import intance from '../utils/axios';
import { getUrlBase } from '../utils';
import { IHttpAdapter } from "../interfaces";



// EN EL ERROR SE ATRAPAN LOS ERRORES QUE SE FORMATEN EN EN CATCH DE axios.ts 
export class AxiosAdapter implements IHttpAdapter{

    
    private url_base = getUrlBase();

    private  axios: AxiosInstance = intance;

    

    async get<T>(url: string): Promise<T> {


        try {

            const  { data }  = await this.axios.get<T>(this.url_base+''+url);
        
            return data;
            
        } catch (error:any) {
            
            const resp:any = {
                ok: false,
                code: error.code,
                message: error.message,
                errors: error.errors
            }
            return resp;
            
        }
        
        
    }

    async getImages<T>(url: string): Promise<T> {
        
        const  { data }  = await this.axios.get<T>(this.url_base+''+url,{
            responseType: 'blob'
        });
        
        return data;
    }

    async post<T>(url: string, data_create: any, setPercentageUploadRut:any): Promise<T> {
        try {
             const { data } = await this.axios.post<T>(this.url_base+''+url, data_create, {

                    onUploadProgress(progressEvent:any) {
                        let percentComplete:any = progressEvent.loaded / progressEvent.total
                        percentComplete = parseInt(percentComplete);
                        setPercentageUploadRut(percentComplete * 100);
                    },
             });
            
             return data;
        } catch (error:any) {


            const resp:any = {
                ok: false,
                code: error.code,
                message: error.message,
                errors: error.errors
            }
            return resp;
        }
    }



    async postLogin<T>(url: string, data_create: any ): Promise<T> {
        try {

             const { data } = await this.axios.post<T>(this.url_base+''+url, data_create);
            
             return data;
        } catch (error:any) {


            const resp:any = {
                ok: false,
                code: error.code,
                message: error.message,
                errors: error.errors
            }
            return resp;
        }
    }
    
    async put<T>(url: string, data_create: any): Promise<T> {

        try {

            const { data } = await this.axios.put<T>(this.url_base+''+url, data_create);

            return data;
            
            
        } catch (error:any) {

            const resp:any = {
                ok: false,
                code: error.code,
                message: error.message,
                errors: error.errors
            }
            return resp;
            
        }

        
    }

    async patch<T>(url: string): Promise<T> {
        

        try {

            const { data } = await this.axios.patch<T>(this.url_base+''+url);

            return data;
            
        } catch (error:any) {

            const resp:any = {
                ok: false,
                code: error.code,
                message: error.message,
                errors: error.errors
            }
            return resp;
            
        }
    }


    // url: string, data_create: any, setPercentageUploadRut:any
    async delete<T>(url: string): Promise<T> {

        try {

            const { data } = await this.axios.delete<T>(this.url_base+''+url);

            return data;
            
        } catch (error:any) {

            console.log('axios.adapter')
            console.log(error)

            const resp:any = {
                ok: false,
                code: error.code,
                message: error.message,
                errors: error.errors
            }
            return resp;
            
        }

        
    }

} 